// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TYCSv","colBig":"styles_colBig__2pXNc","colSmall":"styles_colSmall__2ZWJO"};